import { Component } from 'react';

class App extends Component {
  componentDidMount() {
    this.handleRedirect();
  }

  handleRedirect() {
    const { pathname } = window.location;
    const newBaseUrl = 'https://app.alliot.cloud';

    // Redirect mapping for legacy routes
    const redirects = [
      {
        // /building/assets/:barcode/validity_periods => /app/assets/:barcode?tab=vp
        pattern: /^\/building\/assets\/([^/]+)\/validity_periods\/?$/,
        redirect: (match) => `${newBaseUrl}/app/assets/${match[1]}?tab=vp`
      },
      {
        // /building/inventory-checkers/ => /app/inventory-checkers
        pattern: /^\/building\/inventory-checkers\/?/,
        redirect: () => `${newBaseUrl}/app/inventory-checkers`
      }
    ];

    // Check for matching redirects
    for (const { pattern, redirect } of redirects) {
      const match = pathname.match(pattern);
      if (match) {
        window.location.href = redirect(match);
        return;
      }
    }

    // Default redirect to new app
    window.location.href = newBaseUrl;
  }

  render() {
    return null;
  }
}

export default App;
